export default __webpack_public_path__ + "static/media/vultr-horizontal.3bb93a25.svg";